import { format } from "date-fns";
import RoadSpinner from "../../components/loads/RoadSpinner";

const Configuraciones = ({
    provincias,
    banners,
    categorias,
    categoriasNotas,
    loading,
    onClick,
    onChange,
    setFilter,
    filter,
    modal,
    form,

    setBanners,
    setCategorias,
    setCategoriasNotas
}) => {

    return (
        <div className="min-vh-100 container">
            <div className="py-4 border px-4 mb-4" style={{ borderRadius: "30px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <h2 className="me-2">Provincias Habilitadas</h2>
                    <label
                        className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
                        style={{ borderRadius: "10px", height: "45px" }}
                    >
                        Nueva Provincia
                        <button
                            className="d-none"
                            name="nuevo_evento"
                            onClick={(event) => onClick(event)}
                        ></button>
                    </label>
                </div>
                <div className="row">
                    <div className="col-md-12 px-3">
                        <table class="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="">
                                        <div className="d-flex justify-content-between">NOMBRE</div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">
                                            ESTADO
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={10}>
                                            <RoadSpinner />
                                        </td>
                                    </tr>
                                ) : (
                                    provincias?.map((nota) => {
                                        return (
                                            <tr key={nota.id}>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.nombre}
                                                </td>
                                                <td className="d-none d-md-table-cell">
                                                    <div class="dropdown">
                                                        <button
                                                            class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                                            style={{ borderRadius: "10px" }}
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <span className="text-dark">{nota.stated}</span>
                                                        </button>
                                                        <ul
                                                            class="dropdown-menu"
                                                            aria-labelledby="dropdownMenuButton1"
                                                        >
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                                                    Activar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "ACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                                                    Pausar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "INACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-danger mx-1 bi bi-trash"></i>
                                                                    Eliminar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "PAUSADO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className={`btn btn-sm btn-outline-dark`}>
                                                        <i class="bi bi-pencil-square"></i>
                                                        <button
                                                            className="d-none"
                                                            name="editar"
                                                            onClick={(e) => onClick(e, nota.id)}
                                                        ></button>
                                                    </label>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="py-4 border px-4 mb-4" style={{ borderRadius: "30px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <h2 className="me-2">Categorias</h2>
                    <label
                        className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
                        style={{ borderRadius: "10px", height: "45px" }}
                    >
                        Nueva Categoria
                        <button
                            className="d-none"
                            name="nuevo_evento"
                            onClick={(event) => onClick(event)}
                        ></button>
                    </label>
                </div>
                <div className="row">
                    <div className="col-md-6 px-3">
                        <table class="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="">
                                        <div className="d-flex justify-content-between">TITULO</div>
                                    </th>
                                    <th className="">
                                        <div className="d-flex justify-content-between">TIPO</div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">
                                            ESTADO
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={10}>
                                            <RoadSpinner />
                                        </td>
                                    </tr>
                                ) : (
                                    categorias?.map((nota) => {
                                        return (
                                            <tr key={nota.id}>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.nombre}
                                                </td>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.tipo}
                                                </td>
                                                <td className="d-none d-md-table-cell">
                                                    <div class="dropdown">
                                                        <button
                                                            class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                                            style={{ borderRadius: "10px" }}
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <span className="text-dark">{nota.stated}</span>
                                                        </button>
                                                        <ul
                                                            class="dropdown-menu"
                                                            aria-labelledby="dropdownMenuButton1"
                                                        >
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                                                    Activar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "ACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                                                    Pausar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "INACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-danger mx-1 bi bi-trash"></i>
                                                                    Eliminar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "PAUSADO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className={`btn btn-sm btn-outline-dark`}>
                                                        <i class="bi bi-pencil-square"></i>
                                                        <button
                                                            className="d-none"
                                                            name="editar"
                                                            onClick={(e) => onClick(e, nota.id)}
                                                        ></button>
                                                    </label>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6  px-3">
                        <table class="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="">
                                        <div className="d-flex justify-content-between">TITULO</div>
                                    </th>
                                    <th className="">
                                        <div className="d-flex justify-content-between">TIPO</div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">
                                            ESTADO
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={10}>
                                            <RoadSpinner />
                                        </td>
                                    </tr>
                                ) : (
                                    categorias?.map((nota) => {
                                        return (
                                            <tr key={nota.id}>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.nombre}
                                                </td>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.tipo}
                                                </td>
                                                <td className="d-none d-md-table-cell">
                                                    <div class="dropdown">
                                                        <button
                                                            class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                                            style={{ borderRadius: "10px" }}
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <span className="text-dark">{nota.stated}</span>
                                                        </button>
                                                        <ul
                                                            class="dropdown-menu"
                                                            aria-labelledby="dropdownMenuButton1"
                                                        >
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                                                    Activar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "ACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                                                    Pausar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "INACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-danger mx-1 bi bi-trash"></i>
                                                                    Eliminar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "PAUSADO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className={`btn btn-sm btn-outline-dark`}>
                                                        <i class="bi bi-pencil-square"></i>
                                                        <button
                                                            className="d-none"
                                                            name="editar"
                                                            onClick={(e) => onClick(e, nota.id)}
                                                        ></button>
                                                    </label>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="py-4 border px-4" style={{ borderRadius: "30px" }}>
                <div className="d-flex justify-content-between mb-3">
                    <h2 className="me-2">Banners</h2>
                    <label
                        className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
                        style={{ borderRadius: "10px", height: "45px" }}
                    >
                        Nuevo banner
                        <button
                            className="d-none"
                            name="nuevo_banner"
                            onClick={(event) => onClick(event)}
                        ></button>
                    </label>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-3 mb-3">
                                <input
                                    className="form-control border border-dark py-1"
                                    style={{ borderRadius: "10px 0px 0px 10px" }}
                                    type="search"
                                    name="search"
                                    placeholder="Buscar"
                                    onChange={(e) => onChange(e)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter")
                                            onClick({ target: { name: "search" } });
                                    }}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <select
                                    class="form-select"
                                    aria-label="Default select example"
                                    onChange={(e) => {
                                        if (e.target.value == "todos") {
                                            let params = filter;
                                            delete params["filter[stated]"];
                                            setFilter({ ...params });
                                            return fetch(setBanners, params, "/notas");
                                        }
                                        setFilter({
                                            ...filter,
                                            ["filter[stated]"]: e.target.value,
                                        });
                                        let params = {
                                            ...filter,
                                            ["filter[stated]"]: e.target.value,
                                        };
                                        fetch(setBanners, params, "/categorias");
                                    }}
                                >
                                    {["filter[stated]"] in filter ? (
                                        <option selected>
                                            {
                                                [
                                                    { value: "Todos", label: "Todos" },
                                                    { value: "ACTIVO", label: "Activo" },
                                                    { value: "PAUSADO", label: "Pausado" },
                                                    { value: "ELIMINADO", label: "Eliminado" },
                                                    { value: "BORRADOR", label: "Borrador" },
                                                ].filter((c) => c.value == filter["filter[stated]"])[0]
                                                    .label
                                            }
                                        </option>
                                    ) : (
                                        <option selected>Seleccionar estado</option>
                                    )}
                                    {[
                                        { value: "Todos", label: "Todos" },
                                        { value: "ACTIVO", label: "Activo" },
                                        { value: "PAUSADO", label: "Pausado" },
                                        { value: "ELIMINADO", label: "Eliminado" },
                                        { value: "BORRADOR", label: "Borrador" },
                                    ].map((status, index) => {
                                        if (["filter[stated]"] in filter) {
                                            if (filter["filter[stated]"] == status.value) {
                                                return "";
                                            }
                                        }
                                        return <option key={index} value={status.value}>{status.label}</option>;
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card col-md-12">
                        <table class="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">#ID</div>
                                    </th>
                                    <th className="">
                                        <div className="d-flex justify-content-between">TITULO</div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">PROVINCIA</div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">
                                            POSICIÓN
                                        </div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">
                                            VIGENCIA
                                        </div>
                                    </th>
                                    <th className="d-none d-md-table-cell">
                                        <div className="d-flex justify-content-between">ESTADO</div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={10}>
                                            <RoadSpinner />
                                        </td>
                                    </tr>
                                ) : (
                                    banners?.data.map((nota) => {
                                        return (
                                            <tr key={nota.id}>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    #{nota.id}
                                                </td>
                                                <td className="">
                                                    <div className="d-flex align-items-center">
                                                        <img
                                                            src={
                                                                nota.imagen.includes("https") ? nota.imagen : `https://antesala.com.ar/assets/img/galeria/${nota.imagen}`
                                                            }
                                                            alt="Evento"
                                                            className="rounded me-3"
                                                            width="48"
                                                            height="48"
                                                        />
                                                        <span className="fw-medium">{nota.nombre}</span>
                                                    </div>
                                                </td>
                                                <td className="d-none d-md-table-cell">
                                                    {nota.provincia}
                                                </td>
                                                <td className="Grifter d-none d-md-table-cell">
                                                    {nota.posicion}
                                                </td>
                                                <td className="d-none d-md-table-cell">

                                                    {
                                                        JSON.parse(nota.vigencia)
                                                            ? 'DESDE ' + JSON.parse(nota.vigencia)[0] + ' HASTA ' + JSON.parse(nota.vigencia)[1]
                                                            : ""
                                                    }
                                                </td>
                                                <td className="d-none d-md-table-cell">
                                                    <div class="dropdown">
                                                        <button
                                                            class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                                            style={{ borderRadius: "10px" }}
                                                            type="button"
                                                            id="dropdownMenuButton1"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                        >
                                                            <span className="text-dark">{nota.stated}</span>
                                                        </button>
                                                        <ul
                                                            class="dropdown-menu"
                                                            aria-labelledby="dropdownMenuButton1"
                                                        >
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                                                    Activar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "ACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                                                    Pausar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "INACTIVO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                            <li>
                                                                <label className="btn m-0 p-0">
                                                                    <i class="text-danger mx-1 bi bi-trash"></i>
                                                                    Eliminar
                                                                    <button
                                                                        className="d-none"
                                                                        name="stated"
                                                                        onClick={(event) =>
                                                                            onClick(event, {
                                                                                id: nota.id,
                                                                                status: "PAUSADO",
                                                                            })
                                                                        }
                                                                    ></button>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <label className={`btn btn-sm btn-outline-dark`}>
                                                        <i class="bi bi-pencil-square"></i>
                                                        <button
                                                            className="d-none"
                                                            name="editar_banner"
                                                            onClick={(e) => onClick(e, nota.id)}
                                                        ></button>
                                                    </label>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal para nuevo/editar banner */}
            {modal.banner.status && (
                <div
                    className="modal d-block effect-blur bg-dark bg-opacity-25 align-middle"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                    style={{ zIndex: 104 }}
                >
                    <div
                        className="bg-light modal-dialog animation-modal my-md-5 overflow-hidden texto-normal"
                        style={{ maxWidth: "900px" }}
                    >
                        <div className="modal-content bg-light">
                            <div className="title m-0 bg-white p-4 d-flex justify-content-between">
                                <div>
                                    <h2>{modal.banner.data ? 'Editar Banner' : 'Nuevo Banner'}</h2>
                                    <span className="fs-6 text-muted">
                                        {modal.banner.data ? 'Modifica los datos del banner' : 'Completa los datos del banner'}
                                    </span>
                                </div>
                                <div>
                                    <button
                                        className="border-0 bg-transparent"
                                        name="cerrar_modal"
                                        onClick={(event) => onClick(event)}
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </div>
                            <div className="body p-4">
                                <div className="p-3">
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Nombre
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="nombre"
                                                value={form.nombre[0]}
                                                onChange={(e) => onChange(e)}
                                            />
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Imagen del Banner
                                            </label>
                                            {form.imagen_actual && form.imagen_actual[0] && (
                                                <div className="mb-2">
                                                    <img
                                                        src={
                                                            form.imagen_actual[0].includes("https")
                                                                ? form.imagen_actual[0]
                                                                : `https://antesala.com.ar/assets/img/galeria/${form.imagen_actual[0]}`
                                                        }
                                                        alt="Banner actual"
                                                        className="rounded"
                                                        style={{ maxWidth: "200px", maxHeight: "100px", objectFit: "cover" }}
                                                    />
                                                    <div className="text-muted mt-1" style={{ fontSize: "12px" }}>
                                                        Imagen actual - Selecciona un archivo para cambiarla
                                                    </div>
                                                </div>
                                            )}
                                            <input
                                                type="file"
                                                className="form-control"
                                                name="imagen"
                                                accept="image/*"
                                                onChange={(e) => onChange(e)}
                                            />
                                            {form.imagen[0] && (
                                                <div className="mt-2">
                                                    <small className="text-success">
                                                        Nuevo archivo seleccionado: {form.imagen[0].name}
                                                    </small>
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Provincia
                                            </label>
                                            <select
                                                className="form-select"
                                                name="provincia"
                                                value={form.provincia[0]}
                                                onChange={(e) => onChange(e)}
                                            >
                                                <option value="">Seleccionar provincia</option>
                                                {provincias?.map((provincia) => (
                                                    <option key={provincia.id} value={provincia.nombre}>
                                                        {provincia.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Posición
                                            </label>
                                            <select
                                                className="form-select"
                                                name="posicion"
                                                value={form.posicion[0]}
                                                onChange={(e) => onChange(e)}
                                            >
                                                <option value="">Seleccionar posición</option>
                                                <option value="CARUSEL">Principal</option>
                                                <option value="BANER00">Banner 00</option>
                                                <option value="BANER01">Banner 01</option>
                                                <option value="FESTIVAL">Festival</option>
                                            </select>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Vigencia Desde
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="vigencia_desde"
                                                value={form.vigencia_desde[0]}
                                                onChange={(e) => onChange(e)}
                                            />
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Vigencia Hasta
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="vigencia_hasta"
                                                value={form.vigencia_hasta[0]}
                                                onChange={(e) => onChange(e)}
                                            />
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <label className="form-label text-muted" style={{ fontSize: "14px" }}>
                                                Estado
                                            </label>
                                            <select
                                                className="form-select"
                                                name="stated"
                                                value={form.stated[0]}
                                                onChange={(e) => onChange(e)}
                                            >
                                                <option value="ACTIVO">Activo</option>
                                                <option value="PAUSADO">Pausado</option>
                                                <option value="BORRADOR">Borrador</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer bg-white p-4">
                                <div className="d-flex justify-content-between">
                                    <div></div>
                                    <div>
                                        <button
                                            className="btn btn-secondary rounded-pill px-4"
                                            name="cerrar_modal"
                                            onClick={(event) => onClick(event)}
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            name="guardar_banner"
                                            onClick={(event) => onClick(event)}
                                            className="ms-2 btn btn-custom-amarillo text-white"
                                            disabled={loading}
                                        >
                                            {loading ? 'Guardando...' : 'Guardar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Configuraciones